import {Validated, Length, NotNull} from "./commonRules";
import {checkDZ} from '../../api/guarantee'
// import request from "@/api/axios";
import axios from '../..//api/commAxios'

/**
 * 内部方法, 判断value是否存在
 * @param value 表单数据
 * @returns {*|boolean} 存在返回true, 否则返回false
 * @private
 */
function _valueExist(value) {
    if (typeof value == 'string' || value.constructor == String) {
        // 如果是字符串类型数据去除两侧空格再校验
        value = value.trim();
    }
    return value && value !== "undefined";
}

/**
 * 邮箱格式校验规则
 * @param {boolean} required 是否必填
 * @returns {Validated}
 * @constructor
 */
function EmailRule(required) {
    return new Validated('string', value => {
        if (value.length > 50) {
            return '邮箱最大限制50个字符'
        }
        // if (!_valueExist(value)) {
        //     return '请输入邮箱';
        // }
        // if (!/^([a-zA-Z0-9_-]{1,16})@([a-zA-Z0-9]{1,9})(\.[a-zA-Z0-9]{1,9}){0,3}(\.(?:com|net|org|edu|gov|mil|cn|us)){1,4}$/.test(value)) {
        //     return "邮箱输入有误";
        // }
    }, required);
}

/**
 * 证件号码校验规则
 * @param {int} type 证件类型
 * @param {boolean} required 是否必填
 * @returns {Validated}
 * @constructor
 */
function ZjhmRule(type, required) {
    return new Validated('string', value => {
        if (type == 1) {
            // 身份证号
            if (!_valueExist(value)) {
                return "请输入证件号码";
                //} else if (!/(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)|(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/.test(value)) {
            } else if (!checkCard(value)) {
                return "证件号码输入有误";
            } else{
                if (String(value).length > 18) {
                    return "证件号码最大限制18位";
                }
            }
        }
        if(type != 1){
            if (!_valueExist(value)) {
                return "请输入证件号码";
            }
            if (value.length > 18) {
                return "证件号码最大限制18位";
            }
        }
    }, required);
}

var checkCard = function (obj) {
    console.log('--checkCard',obj);
    //var card = document.getElementById('card_no').value;
    //是否为空
    // if(card === '')
    // {
    //  return false;
    //}
    //校验长度，类型
    if (isCardNo(obj) === false) {
        return false;
    }
    //检查省份
    if (checkProvince(obj) === false) {
        return false;
    }
    //校验生日
    if (checkBirthday(obj) === false) {
        return false;
    }
    //检验位的检测
    if (checkParity(obj) === false) {
        return false;
    }
    return true;
};

//检查号码是否符合规范，包括长度，类型
var isCardNo = function (obj) {
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
    var reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
    if (reg.test(obj) === false) {
        return false;
    }
    return true;
};
//取身份证前两位,校验省份
var vcity = {
    11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古",
    21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏",
    33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南",
    42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆",
    51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃",
    63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外"
};
var checkProvince = function (obj) {
    var province = obj.substr(0, 2);
    if (vcity[province] == undefined) {
        return false;
    }
    return true;
};
//检查生日是否正确
var checkBirthday = function (obj) {
    var len = obj.length;
    //身份证15位时，次序为省（3位）市（3位）年（2位）月（2位）日（2位）校验位（3位），皆为数字
    if (len == '15') {
        var re_fifteen = /^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/;
        var arr_data = obj.match(re_fifteen);
        var year = arr_data[2];
        var month = arr_data[3];
        var day = arr_data[4];
        var birthday = new Date('19' + year + '/' + month + '/' + day);
        return verifyBirthday('19' + year, month, day, birthday);
    }
    //身份证18位时，次序为省（3位）市（3位）年（4位）月（2位）日（2位）校验位（4位），校验位末尾可能为X
    if (len == '18') {
        var re_eighteen = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
        var arr_data = obj.match(re_eighteen);
        var year = arr_data[2];
        var month = arr_data[3];
        var day = arr_data[4];
        var birthday = new Date(year + '/' + month + '/' + day);
        return verifyBirthday(year, month, day, birthday);
    }
    return false;
};
//校验日期
var verifyBirthday = function (year, month, day, birthday) {
    var now = new Date();
    var now_year = now.getFullYear();
    //年月日是否合理
    if (birthday.getFullYear() == year && (birthday.getMonth() + 1) == month && birthday.getDate() == day) {
        //判断年份的范围（3岁到100岁之间)
        var time = now_year - year;
        if (time >= 0 && time <= 130) {
            return true;
        }
        return false;
    }
    return false;
};
//校验位的检测
var checkParity = function (obj) {
    //15位转18位
    obj = changeFivteenToEighteen(obj);
    var len = obj.length;
    if (len == '18') {
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var cardTemp = 0, i, valnum;
        for (i = 0; i < 17; i++) {
            cardTemp += obj.substr(i, 1) * arrInt[i];
        }
        valnum = arrCh[cardTemp % 11];
        if (valnum == obj.substr(17, 1)) {
            return true;
        }
        return false;
    }
    return false;
};
//15位转18位身份证号
var changeFivteenToEighteen = function (obj) {
    if (obj.length === '15') {
        var arrInt = Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var cardTemp = 0, i;
        obj = obj.substr(0, 6) + '19' + obj.substr(6, obj.length - 6);
        for (i = 0; i < 17; i++) {
            cardTemp += obj.substr(i, 1) * arrInt[i];
        }
        obj += arrCh[cardTemp % 11];
        return obj;
    }
    return obj;
};




/**
 * 手机号校验规则
 * @param {boolean} [required] 是否必传
 * @returns {Validated}
 * @constructor
 */
function PhoneRule(required) {
    return new Validated('string', value => {
        if (!_valueExist(value)) {
            return "请输入手机号";
        }
        if (!/(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/.test(value)) {
            return '手机号输入有误';
        }
    }, required);
}

/**
 * 姓名校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function XmRule(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入姓名";
        }
        if (value.length > 20) {
            return "姓名最大限制为20个字符";
        }
    }, required);
}

/**
 * 年龄
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function NlRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入年龄";
        }
        if (!/^(?:[1-9][0-9]?|1[01][0-9]|120)$/.test(value)) {
            return "年龄最大限制为120岁";
        }
    }, required);
}

/**
 * 案件类型代字
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
var fydz=/^(刑初|刑终|刑再|刑没|民初|民终|民再|民撤|行初|行终|行再|行审|行审复|行赔初|行赔终|行赔再|认台|认港|认澳|认复)$/;
var fydz2=/^知(民初|民终|民监|民申|民抗|民再|行初|行终|行监|行申|行抗|行再)$/;
function AjlxdzRule(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入案件类型代字";
        }
        if (!(fydz.test(value)||fydz2.test(value))) {
            return "案件类型代字不正确";
        }
    }, required);
}

/**
 * 法院代字
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function FydzRule(required,cFyid) {
    return new Validated("string", value => {
        console.log('--法院代字 123',value,cFyid);
        if (!_valueExist(value)) {
            return "请输入法院代字";
        }
        /*if (!/^(最高法|京|津|冀|内|辽|吉|黑|沪|苏|浙|皖|闽|赣|鲁|豫|鄂|湘|粤|桂|琼|渝|川|黔|云|藏|陕|甘|青|宁|新|兵|军)\d{0,4}$/.test(value)) {
            return "法院代字不正确";
        }*/
        async function main(){
            let p=new Promise((resolve, reject) => {
                axios.get("ssbq/api/dz?fyId=" + cFyid)
                    .then(res => {
                        console.log('--checkDZ 123', res);
                        // if (res.data !== value.trim()) {
                        var filed=res.data.length>0?res.data.substr(0,1):'';
                        if(filed.length===1&&value.trim().indexOf(filed) >-1 ){
                        // if (value.trim().indexOf(res.data) === -1 ) {
                            // resolve("法院代字和申请法院不匹配");
                            resolve();
                        }else{
                            resolve("法院代字不正确");
                        }

                    }).catch((error) => {
                    console.log(1,error)
                    reject("法院代字不正确");
                });
            });
            let result = await p;
            return result;
        }

        let aa = main();
        // console.log('--aa',aa,aa instanceof Promise);
        return aa;
    }, required);
}

/**
 * 案件序号
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function AjxhRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入案件序号";
        }
        if (!/^\d{0,5}$/.test(value)) {
            return "案件序号最大为5位数字";
        }
    }, required);
}

/**
 * 车牌号
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function CphRule(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入车牌号";
        }
        if (!/^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[a-zA-Z](([DF]((?![IO])[a-zA-Z0-9](?![IO]))[0-9]{4})|([0-9]{5}[DF]))|[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1})$/.test(value)) {
            return "请输入正确的车牌号";
        }
    }, required);
}

/**
 * 数额限制
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function SexzRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入数额";
        }
        if (!/^([+]?\d{0,13})(\.\d{1,2})?$/.test(value)) {
            return "数额最大限制为13位且最多保留2位小数";
        }
    }, required);
}

/**
 * 单位名称
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function QymcRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入单位名称",
        max: 100,
        maxErrorMsg: "单位名称最大限制为100个字符"
    });
}

/**
 * 企业法人
 * @param type 申请人类型, 2法定代表人, 3主要负责人
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function QyfrRule(type, required) {
    if (type == 2) {
        return new Length({
            required: required,
            errorMsg: "请输入法定代表人",
            max: 20,
            maxErrorMsg: "法定代表人最大限制为20个字符"
        });
    }
    if (type == 3) {
        return new Length({
            required: required,
            errorMsg: "请输入主要负责人",
            max: 20,
            maxErrorMsg: "主要负责人最大限制为20个字符"
        });
    }
}

/**
 * 通讯地址, 家庭住址, 单位地址
 * @param type 申请人类型, 1自然人, 2法定代表人, 3主要负责人
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function TxdzRule(type, required) {
    if (type == 1) {
        return new Length({
            required: required,
            errorMsg: "请输入经常居住地",
            max: 100,
            min: 6,
            minErrorMsg: "经常居住地需大于6位字符且不得超过100个字符",
            maxErrorMsg: "经常居住地需大于6位字符且不得超过100个字符"
        });
    } else {
        return new Length({
            required: required,
            errorMsg: "请输入单位地址",
            max: 100,
            min: 6,
            minErrorMsg: "单位地址需大于6位字符且不得超过100个字符",
            maxErrorMsg: "单位地址需大于6位字符且不得超过100个字符"
        });
    }
}

/**
 * 证照类型
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function ZzlxRule(required) {
    return new Length({
        required: required,
        errorMsg: "请选择证照类型"
    });
}

/**
 * 统一社会信用代码
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function TyshxydmRule(required) {
    // return new Length({
    //     required: false,
    //     errorMsg: "请输入统一社会信用代码",
    //     max: 20,
    //     maxErrorMsg: "统一社会信用代码最大限制为20位"
    // });
    return new Validated('string', value => {
        if (!_valueExist(value)) {
            return '请输入统一社会信用代码';
        }
        if (!/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(value)){
            return "统一社会信用代码输入有误";
        }
    }, required);
}

/**
 * 证照号码
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function CQyzzjgdmRule(type,required){
    console.log('--CQyzzjgdmRule 111',type);
    return new Validated('string', value => {
        var codeList=[1,2,3];
        if (!_valueExist(value)) {
            return '请输入证照号码';
        }else if(codeList.includes(type)&&String(value).length > 18){
            return "证照号码最大限制18位";
        }else if(type===4&&!/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(value)){
            return '证照号码输入有误';
        } else if(type===255&&String(value).length > 50){
            return '证照号码最大限制50位';
        }
    },required);
}

/**
 * 基金数量
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function JjslRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入基金数量";
        }
        if (!/^\+?[1-9][0-9]*$/.test(value)) {
            return "基金数量只能是正整数";
        }
        if (value.toString().length > 10) {
            return "基金数量最大限制为10位正整数";
        }
    }, required);
}

/**
 * 执业证件号码
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function ZyzjhmRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入执业证号",
        max: 17,
        maxErrorMsg: "执业证号最大限制为17个字符"
    });
}

/**
 * 律所
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function LsRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入代理人所在律所",
        max: 100,
        maxErrorMsg: "代理人所在律所最大限制为100个字符"
    });
}

/**
 * 开户银行名称
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function KhyhmcRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入开户银行名称",
        max: 100,
        maxErrorMsg: "开户银行名称最大限制为100个字符"
    });
}

/**
 * 开户银行账号限制
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function KhyhzhRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入开户账号";
        }
        // if (!/^\d{0,20}$/.test(value)) {
        if (!/^\d{0,50}$/.test(value)) {
            return "开户账号最大限制为50位";
        }
    }, required);
}

/**
 * 房屋坐落位置
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function FwzlwzRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入房产坐落位置",
        max: 100,
        maxErrorMsg: "房产坐落位置最大限制为100个字符"
    });
}

/**
 * 房产证号
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function FczhRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入房产证号",
        max: 50,
        maxErrorMsg: "房产证号最大限制为50个字符"
    });
}


/**
 * 地址或权属
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function DzhqsRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入地址",
        max: 100,
        maxErrorMsg: "地址最大限制为100个字符"
    });
}

/**
 * 土地面积
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function TdmjRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入面积";
        }
        if (!/^([+]?\d{0,10})(\.\d{1,2})?$/.test(value)) {
            return "面积最大限制为10位且最多保留两位小数";
        }
    }, required);
}

/**
 * 产权证号
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function CqzhRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入产权证号",
        max: 50,
        maxErrorMsg: "产权证号最大限制为50个字符"
    });
}

/**
 * 股票名称
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function GpmcRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入股票名称",
        max: 100,
        maxErrorMsg: "股票名称最大限制为100位"
    });
}

/**
 * 股票代码
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function GpdmRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入股票代码",
        max: 20,
        maxErrorMsg: "股票代码最大限制为20个字符"
    });
}

/**
 * 持股数量
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function CgslRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入持股数量";
        }
        if (!/^([+]?\d{0,10})$/.test(value)) {
            return "持股数量不能超过10位整数";
        }
    }, required);
}

/**
 * 基金名称
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function JjmcRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入基金名称",
        max: 100,
        maxErrorMsg: "基金名称最大限制为100个字符"
    });
}

/**
 * 债券名称
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function ZqmcRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入债券名称",
        max: 100,
        maxErrorMsg: "债券名称最大限制为100个字符"
    });
}

/**
 * 债券面值
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function ZqmzRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入债券面值";
        }
        if (!/^([+]?\d{0,10})(\.\d{1,2})?$/.test(value)) {
            return "债券面值最大限制为10位的整数且最多保留2位小数";
        }
    }, required);
}

/**
 * 持股公司名称
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function CggsmcRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入持股公司名称",
        max: 100,
        maxErrorMsg: "持股公司名称最大限制为100个字符"
    });
}

/**
 * 出资比例
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function CzblRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入出资比例";
        }
        if (!/^(\d|[1-9]\d|100)(\.\d{1,2})?$/.test(value)) {
            return "出资比例不得大于100%，最多保留2位小数";
        }
    }, required);
}

/**
 * 设备名称
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function CsbmcRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入您的设备名称",
        max: 20,
        maxErrorMsg: "设备名称最大限制为20个字符"
    });
}

/**
 * 描述
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function MsRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入您的描述",
        max: 200,
        maxErrorMsg: "描述内容最大限制为200个字符"
    });
}

/**
 * 财产价值
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function CzjzRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入财产价值";
        }
        if (!/^([+]?\d{0,13})(\.\d{1,2})?$/.test(value)) {
            return "财产价值最大限制为13位保留2位小数";
        }
    }, required);
}

/**
 * 申请保全金额
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function SqbqjeRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入申请保全金额";
        }
        if (!/^([+]?\d{0,13})(\.\d{1,2})?$/.test(value)) {
            return "申请保全金额最大限制为13位保留2位小数";
        }
    }, required);
}

/**
 * 咨询员编号
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function ZxybhRule(required) {
    return new Length({
        required: required,
        max: 64,
        maxErrorMsg: "咨询员编号最大限制为64个字符"
    });
}


/**
 * 担保人
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function DbrRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入担保人",
        max: 50,
        maxErrorMsg: "担保人最大限制为50个字符"
    });
}

/**
 * 担保价值
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function DbjzRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入担保价值";
        }
        if (!/^([+]?\d{0,13})(\.\d{1,2})?$/.test(value)) {
            return "担保价值最大限制为13位整数且最多保留2位小数";
        }
    }, required);
}

/**
 * 区号
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function QhRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入区号";
        }
        if (!/\b0\d{2,3}\b/.test(value)) {
            return "区号输入不正确";
        }
    }, required);
}


/**
 * 电话号码
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function DhhmRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入电话号码";
        }
        if (!/\b\d{7,8}\b/.test(value)) {
            return "电话号码输入不正确";
        }
    }, required);
}

/**
 * 分机号
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function FjhRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入分机号";
        }
        if (!/\b\d{3,4}\b/.test(value)) {
            return "分机号输入不正确";
        }
    }, required);
}

/**
 * 固定电话
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function GddhRule(required) {
    return new Validated("number", value => {
        if (!_valueExist(value)) {
            return "请输入固定电话";
        }
        if (!/^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/.test(value)) {
            return "固定电话输入不正确";
        }
        // if (!/^[0-9]{0,18}$/.test(value)) {
        //     return "固定电话最大限制为18位数字";
        // }
        // if (!/^(\d{2,3}\-)?(\d{7,8})+(\-\d{3,4})?$/.test(value)) {
        //     return "固定电话格式不正确";
        // }

    }, required);
}

/**
 * 身份证明类材料校验
 * @param {boolean} [requSqbqjeRuleired] 是否必填
 * @returns {Validated}
 */
function SfzmlclRule(required) {
    return new Validated('array', value => {
        if (!value || value == 'undefined') {
            return '请上传身份证明类材料';
        }
        for (let ryxx of value) {
            if(!ryxx.hasOwnProperty('isCheck')||(ryxx.hasOwnProperty('isCheck')&&ryxx.isCheck===1)){
                if (!ryxx.clList || ryxx.clList == 'undefined' || ryxx.clList.length == 0) {
                    return '请上传' + ryxx.rymc + '的身份证明类材料';
                }
            }
        }
    }, required);
}

/**
 * 担保类材料校验
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 */
function DblclRule(required) {
    return new Validated('array', value => {
        if (!value || value == 'undefined') {
            return '请上传担保类材料';
        }
        for (let dblxx of value) {
            if(dblxx.nSysbuy != 1){
                if (!dblxx.clList || dblxx.clList == 'undefined' || dblxx.clList.length == 0) {
                    return '请上传' + dblxx.dblxmc + '的担保类材料';
                }
            }
        }
    }, required);
}

/**
 * 检验续行和解决的申请原因
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function yyRule(required) {
    return new Length({
        required: required,
        errorMsg: "原因不能为空",
        max: 200,
        maxErrorMsg: "原因不得超过200位字符"
    });
}

/**
 * 检验上传材料大小
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function sizeRule(required) {
    return new Length({
        required: required,
        errorMsg: "上传材料不能为空",
        max: 20971520,
        maxErrorMsg: "最大上传材料为20M",
        processor: fileSize => {
            if (fileSize > 20971520) {
                return "最大上传材料为20M";
            }
        }
    });
}

/**
 * 描述
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function SmRule(required) {
    return new Length({
        required: required,
        errorMsg: "请输入您的说明",
        max: 100,
        maxErrorMsg: "担保说明最大限制为100个字符"
    });
}

/**
 * 案号校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
let bqah = /^\（\d{4}\）(最高法|京|津|冀|内|辽|吉|黑|沪|苏|浙|皖|闽|赣|鲁|豫|鄂|湘|粤|桂|琼|渝|川|黔|云|藏|陕|甘|青|宁|新|兵|军)\d{0,4}(刑初|刑终|刑再|刑没|民初|民终|民再|民撤|行初|行终|行再|行审|行审复|行赔初|行赔终|行赔再|认台|认港|认澳|认复|财保|行保|证保)\d{1,5}号$/i

function AhRule(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入案号";
        }
    if (!bqah.test(value)) {
            return "案号输入有误";
        }
    }, required);
}

/**
 * 案由校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function AyRule(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请选择案由";
        }
        if (value.length > 50) {
            return "案由最大限制为50个字符";
        }
    }, required);
}

function cAyNameRule(required,txt) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请选择"+txt;
        }
    }, required);
}

function cAyxzxwNameRule(required,txt) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请选择"+txt;
        }
    }, required);
}

function cXzaymcRule(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入行政案由名称";
        }
        if (value.length > 300) {
            return "行政案由名称最大限制为300个字符";
        }
    }, required);
}

/**
 * 车辆品牌
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function ClppRule(required) {
    return new Validated("string", value => {
        if (value.length > 20) {
            return "车辆品牌最大限制为20个字符";
        }
    }, required);
}

/**
 * 担保物名称校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function DbwmcRule(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入担保物名称";
        }
        if (value.length > 50) {
            return "担保物名称最大限制为50个字符";
        }
    }, required);
}

/**
 * 担保机构名称校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function BxgsmcRule(required) {
    return new Validated("string", value => {
        if (!_valueExist(value)) {
            return "请输入担保机构名称";
        }
        if (value.length > 50) {
            return "担保机构名称最大限制为50个字符";
        }
    }, required);
}

/**
 * 担保速度校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function nDbsdnRule(required) {
    return new Validated("number", value => {
        if (!value) {
            return "请评价担保速度";
        }
    }, required);
}

/**
 * 服务水平校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function nFwspnRule(required) {
    return new Validated("number", value => {
        if (!value) {
            return "请评价服务水平";
        }
    }, required);
}

/**
 * 理赔服务校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function nLpfwnRule(required) {
    return new Validated("number", value => {
        if (!value) {
            return "请评价理赔服务";
        }
    }, required);
}

/**
 * 评价校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function cYjjyRule(required) {
    return new Validated("string", value => {
        if (value.length > 300) {
            return "评价最大限制为300个字符";
        }
    }, required);
}

/**
 * 申请财产查控原因校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function cSqckyyRule(required) {
    return new Validated("string", value => {
        if(value == ''){
            return '原因不能为空'
        }
        if (value.length > 200) {
            return "原因最大限制为200个字符";
        }
    }, required);
}

/**
 * 提供担保人担保人的校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function cDBRRule(required) {
    return new Validated("string", value => {
        if(value == ''){
            return '请输入担保人'
        }
        if (value.length > 200) {
            return "担保人最大限制为200个字符";
        }
    }, required);
}

/**
 * 复议案号校验规则
 * @param {boolean} [required] 是否必填
 * @returns {Validated}
 * @constructor
 */
function cBqah(required) {
    return new Validated("string", value => {
        if(value == ''){
            return '请输入案号'
        }
        if (!/^（\d{4}）(最高法|京|津|冀|内|辽|吉|黑|沪|苏|浙|皖|闽|赣|鲁|豫|鄂|湘|粤|桂|琼|渝|川|黔|云|藏|陕|甘|青|宁|新|兵|军)\d{0,4}(刑初|刑终|刑再|刑没|民初|民终|民再|民撤|行初|行终|行再|行审|行审复|行赔初|行赔终|行赔再|认台|认港|认澳|认复|财保|行保|证保)\d{1,5}号$/i.test(value)) {
            return "案号输入有误";
        }
    }, required);
}


/**
 * 复议理由
 * @returns {Validated}
 * @constructor
 */
function FylyRule() {
    return new Length({
        required: true,
        errorMsg: "请输入复议理由",
        max: 200,
        maxErrorMsg: "复议理由最大限制为200个字符"
    });
}

const mzRule = new NotNull("string", "请选择民族");
const xbRule = new NotNull('number', '请选择性别');
const csrqRule = new NotNull('date', '请选择出生日期');
const zjyxqKsrqRule = new NotNull('date', '请选择开始日期');
const zjyxqJsrqRule = new NotNull('date', '请选择结束日期');
const nZzlxRule = new NotNull("number", "请选择证照类型");
const zjlxRule = new NotNull('number', '请选择证件类型');
const dwxzRule = new NotNull('number', '请选择单位性质');
const cclxRule = new NotNull('number', '请选择财产类型');
const ccsyrRule = new NotNull('number', '请选择财产所有人');
const bzRule = new NotNull('number', '请选择币种');
const tddwRule = new NotNull('number', '请选择土地面积单位');
const ssygRule = new NotNull('array', '请选择申请人');
const sqrRule= new NotNull('string', '请选择申请人');
const dlrlxRule = new NotNull('string', '请选择代理人类型');
const gddhRule = new NotNull('string', '请输入固定电话');
const xzfyRule = new NotNull('number', '请选择法院');
const bqlbRule = new NotNull('number', '请选择保全类别');
const bxgsRule = new NotNull('number', '请选择担保机构');
const fsqjRule = new NotNull('number', '请选择非诉期间');
const tjrsfRule = new NotNull('number', '请输入提交人身份');
const ajlxRule = new NotNull('number', '请选择案件类型');
const bgdbsqsclRule = new NotNull('array', '请上传变更担保申请书材料');
const bgsqsclRule = new NotNull('array', '请上传变更后保全申请书材料');
const sqsclRule = new NotNull('array', '请上传申请书材料');
// 解除保全事由规则
const jcbqSqsRule = new NotNull('string', '请先上传解除保全申请书');
// 解除保全事由规则
const jcbqYyRule = new NotNull('string', '请选择解除保全事由');
const sxflwsRule = new NotNull('array', '请上传生效法律文书');
const sqccckRule = new NotNull('array', '请上传财产查控申请书');
const bgqszclRule = new NotNull('array', '请上传变更后起诉状材料');
const qszclRule = new NotNull('array', '请上传起诉状材料');
const zjlclRule = new NotNull('array', '请上传证据类材料');
const lasltzsRule = new NotNull('array', '请上传立案受理通知书');
const bqlxRule = new NotNull('number', '请选择保全类型');
const dbqkRule = new NotNull('number', '请选择担保情况');
const sqrxxRule = new NotNull('array', '请添加申请人信息');
const bsqrxxRule = new NotNull('array', '请添加被申请人信息');
const ygdlrRule = new NotNull('array', '请添加原告代理人信息');
const ccxsxxRule = new NotNull('array', '请添加财产线索信息');
const ccckxxRule = new NotNull('array', '请添加财产查控或财产线索信息');
const userRule = new NotNull('string', '请选择用户类型');
const bcdbyyRule = new NotNull('string', '请输入补充担保原因');
const dbfsRule = new NotNull('number', '请选择担保方式');
const dzdbsRule = new NotNull('array', '请上传担保材料');
const bgdbsqsRule = new NotNull('array', '请上传变更担保申请书');
const xgclRule = new NotNull('array', '请上传相关材料');
const bdhRule = new NotNull('string', '请选择保单号');
const dbxxRule = new NotNull('array', '请添加担保信息');
const bgdbyyRule = new NotNull('string', '请输入变更担保原因');
const bgdbsxRule = new NotNull('number', '请选择变更担保事项');
const wdbyy = new NotNull('number', '请输入无需担保原因');
const fysx = new NotNull('number','请选择复议事项');
const fySqrqRule = new NotNull('string', '请选择申请日期');
const fylyRule = new NotNull('string', '请输入复议理由');
const ssdwRule = new NotNull('string','请输入诉讼地位');
const fySqsRule = new NotNull('array','请上传复议申请书材料');
const fyZjRule = new NotNull('array', '请上传复议证据材料');
const dbclRule  = new NotNull('array', '请上传担保材料');
const xwxxRule = new NotNull('array', '请添加行为信息');
const zjxxRule = new NotNull('array', '请添加证据信息');
const zcslRule = new NotNull('array', '请上传仲裁受理通知书');
const zchRule = new NotNull('array', '请上传仲裁函材料');
const fysqrRule = new NotNull('array', '请添加复议申请人信息');
const khhmcRule = new NotNull('number', '请选择开户行所在地');
const clgsdRule = new NotNull('number', '请选择车辆归属地');
const fxdwRule = new NotNull('number', '请选择发行单位注册地');
const fwzlRule = new NotNull('number','请选择房屋坐落省份');
const tdgsRule = new NotNull('number','请选择土地归属地');
const ahNfRule = new NotNull('string','请选择案号年份');
const cAyName = new NotNull('string','请选择案由主体类型');
const cAyxzxwName = new NotNull('string','请选择案由行为种类');
// 申请续行原因
const cSqxxyy = new NotNull('string','请输入申请人续行原因');
// 担保人
const cDbrRule = new NotNull('string','请输入担保人');
// 担保物名称
const dBwmcRule = new NotNull('string','请输入担保物名称');
// // 证据类型
const nzjlxRule = new NotNull("number", "请选择证据类型");
// 证据类型
const czjmcRule = new NotNull("string", "请输入证据名称");
// 证据来源
const czjlyRule = new NotNull("string", "请输入证据来源");
// 财产描述
const csxsmRule = new NotNull("string", "请输入描述内容");
// 保全开始日期
const dBqksrqRule = new NotNull("string", "请选择保全开始日期");
// 保全结束日期
const dBqjsrqRule = new NotNull("string", "请选择保全结束日期");
// 财产线索列表
const jcxxbqCcxsListRule = new NotNull('string', '请添加财产线索');
// 证据信息列表
const jcxxbqZjxxListRule = new NotNull('string', '请添加证据信息');
// 行为信息列表
const jcxxbqXwxxListRule = new NotNull('string', '请添加行为信息');



export {
    jcxxbqCcxsListRule,
    jcxxbqZjxxListRule,
    jcxxbqXwxxListRule,
    EmailRule, // 邮箱
    ZjhmRule, // 证件号码
    PhoneRule, // 手机号
    XmRule, // 姓名
    NlRule, // 年龄
    AjlxdzRule, // 案件类型代字
    FydzRule, // 法院代字
    AjxhRule, // 案件序号
    CphRule, // 车牌号
    SexzRule, // 数额限制
    QymcRule, // 单位名称
    QyfrRule, // 企业法人
    TxdzRule, // 通讯地址, 家庭住址, 单位地址
    CQyzzjgdmRule,//证照号码
    TyshxydmRule, // 统一社会信用代码
    JjslRule, // 基金数量
    ZyzjhmRule, // 执业证件号码
    LsRule, // 律所
    KhyhmcRule, // 开户银行名称
    KhyhzhRule, // 开户银行账号限制
    FwzlwzRule, // 房屋坐落位置
    FczhRule, // 房产证号
    DzhqsRule, // 地址或权属
    TdmjRule, // 土地面积
    CqzhRule, // 产权证号
    GpmcRule, // 股票名称
    GpdmRule, // 股票代码
    CgslRule, // 持股数量
    JjmcRule, // 基金名称
    ZqmcRule, // 债券名称
    ZqmzRule, // 债券面值
    CggsmcRule, // 持股公司名称
    CzblRule, // 出资比例
    CsbmcRule, //设备名称
    MsRule, // 描述
    CzjzRule, // 财产价值
    SqbqjeRule, // 申请保全金额
    DbjzRule, // 担保价值
    QhRule, // 区号
    DhhmRule, //电话号码
    GddhRule, // 固定电话
    FjhRule, // 分机号
    SfzmlclRule, // 身份证明类材料校验
    mzRule, // 民族
    xbRule, // 性别
    csrqRule, // 出生日期
    zjyxqKsrqRule,  // 证件有效期开始日期
    zjyxqJsrqRule,  // 证件有效期开始日期
    zjlxRule, // 证件类型
    nZzlxRule, //证照类型
    dwxzRule, // 单位性质
    cclxRule, // 财产类型
    ccsyrRule, // 财产所有人
    bzRule, // 币种类型
    tddwRule, // 土地面积
    ssygRule, // 所属原告, 选择申请人
    sqrRule, // 所属原告, 选择申请人
    dlrlxRule, // 代理人类型
    gddhRule, // 固定电话
    xzfyRule, // 选择法院
    bqlbRule, // 保全类别
    bxgsRule, // 选择担保机构
    fsqjRule, // 选择非诉期间
    tjrsfRule, // 选择提交人身份
    ajlxRule, // 选择案件类型
    AhRule, // 输入案号
    AyRule, // 输入案由
    cAyNameRule,//输入行政案由1
    cAyxzxwNameRule,//输入行政案由2
    cXzaymcRule,//行政案由名称
    bgdbsqsclRule,//上传变更担保申请书材料
    bgsqsclRule,// 上传变更后保全申请书材料
    sqsclRule, // 上传申请书材料
    jcbqSqsRule, // 解除保全申请书
    jcbqYyRule, // 请选择解除保全事由
    sxflwsRule, // 上传生效法律文书
    bgqszclRule,// 上传变更后起诉状材料
    qszclRule, // 上传起诉状材料
    zjlclRule, // 证据类材料
    lasltzsRule, // 立案受理通知书材料
    bqlxRule, // 保全类型
    dbqkRule, // 担保情况,
    sqrxxRule, // 申请人信息
    bsqrxxRule, // 被申请人信息
    ygdlrRule, // 原告代理人信息
    ccxsxxRule, // 财产线索信息
    ccckxxRule, // 财产查控信息
    yyRule, // 检验续行和解决的申请原因
    sizeRule, // 检验上传材料大小
    userRule, //用户类型
    bcdbyyRule, // 补充担保原因
    dbfsRule, // 担保方式
    dzdbsRule, // 电子担保书
    bgdbsqsRule, // 变更担保申请书
    xgclRule, // 相关材料
    bdhRule, // 保单号
    DblclRule, // 担保类
    ZxybhRule,//咨询员编号
    DbrRule, // 担保人
    dbxxRule, // 担保信息
    SmRule, // 担保说明
    bgdbyyRule, // 变更担保原因
    bgdbsxRule, // 变更担保事项
    ClppRule, // 车辆品牌
    DbwmcRule, // 担保物名称
    BxgsmcRule, //担保机构名称
    cYjjyRule, //评价
    nDbsdnRule, //担保速度
    nFwspnRule, //服务水平
    nLpfwnRule, //理赔服务
    cSqckyyRule, //申请财产查控原因
    wdbyy,//无担保原因
    sqccckRule,//财产查控
    cBqah,//复议案号
    fysx,//复议事项
    fySqrqRule,//复议申请日期
    fylyRule,//复议理由
    FylyRule, // 复议理由
    ssdwRule,//复议诉讼地位
    fySqsRule,//复议申请书
    fyZjRule,//复议证据材料
    cDBRRule,//提供担保人担保人
    dbclRule,//担保材料
    fysqrRule,
    khhmcRule,
    clgsdRule,
    fxdwRule,
    fwzlRule,
    tdgsRule,
    ahNfRule,//案号年份
    xwxxRule,//行为信息
    zjxxRule,//证据信息
    zcslRule,//仲裁受理通知书'
    zchRule,//仲裁函材料
    // 担保人
    cDbrRule,
    // 担保物名称
    dBwmcRule,
    // 续行申请原因
    cSqxxyy,
    // // 证据类型
    nzjlxRule,
    // 证据名称
    czjmcRule,
    // 证据来源
    czjlyRule,
    // 行为事项说明
    csxsmRule,
    dBqksrqRule,
    dBqjsrqRule
};
